import axiosInstance from "../Common/Axios/axiosInstance";
import API from "../Common/Endpoint/serviceConstrants";

export const callClientMasterGetApi = async (payload) => {
  const { data = [] } = await axiosInstance.get(API.clientbyid, {
    params: {
      PlatformDomainUrl: payload?.platformDomainUrl,
    },
    headers: {
      ...axiosInstance.defaults.headers,
      Userid: process.env.REACT_APP_USER_Name,
      Password: process.env.REACT_APP_USER_PASSWORD,
      Encryption:1,
    },
  });
  return data;
};
